import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";

import { TracingContextService } from "@core/services/tracing/tracing-context.service";
import { generateUUID } from "@utils/encrypt/encrypt";
import { version } from "../../../../../package.json";
import slugify from "@utils/slugify/slugify";

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const tracingContext = inject(TracingContextService);
  const tracingId = slugify(generateUUID());

  const headers: Record<string, string> = {
    "vss-tracing": tracingId,
    "vss-origin": "vss",
    "vss-origin-platform": "web",
    "vss-origin-version": version,
  };

  if (tracingContext.sessionId) {
    headers["vss-session-id"] = tracingContext.sessionId;
  }

  if (tracingContext.traceparent) {
    headers["traceparent"] = tracingContext.traceparent;
  }

  return next(req.clone({ setHeaders: headers }));
};
